<!--
/**
* @name: YResetPassword.vue
* @description: 重置密码
* @author: wenyongjiang
* @create: 2020/08/04 15:16:34
* @update: 2020/08/04 15:16:34
*/
-->
<template>
  <a href="javascript:;" class="link" @click="onReset">重置密码</a>
</template>

<script>
  // import { XTL_USER_SERVER_USER_RESETPASSWORD } from '@/assets/modules/apiList';

  export default {
    props: {
      userName: [String, Number]
    },
    methods: {
      onReset() {
        if (!this.userName) {
          return this.$root.tip('请传入userName参数');
        }
        this.$dialog({
          title: '提醒',
          content: () => <span>确定要重置{this.userName}的密码吗？</span>,
          ok: () => {
            this.toReset(this.userName);
          }
        });
      },
      toReset(userName) {
        this.$fetch({
          api: XTL_USER_SERVER_USER_RESETPASSWORD,
          para: { userName }
        }).then(data => {
          this.$dialog({
            title: '提醒',
            layout: 'mask,header,body,close',
            content: () => (
              <ul>
                <li >{userName}密码已经被重置为：{data}</li>
              </ul>
            )
          });
        });
      }
    }
  };
</script>